export default "__VITE_ASSET__DQQatLXg__"